import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './DocumentManualVerificationModal.module.css'
import { byDesign } from '@/infra/design'
import imgDocumentsUrl from '@/assets/misc/img_documents.svg'
import NoBillingMethodsIllustration from '@/components/SpotIllustration/NoBillingMethodsIllustration'

export interface DocumentManualVerificationModalProps {
  showing: boolean
  onClose: () => unknown
  isMissingProSignature: boolean
  hasViewedDocument: boolean
  onViewDocument: () => unknown
  onConfirmDocument: () => unknown
  onDeleteDocument: () => unknown
}

export function DocumentManualVerificationModal({
  showing,
  onClose,
  isMissingProSignature,
  hasViewedDocument,
  onViewDocument,
  onConfirmDocument,
  onDeleteDocument,
}: DocumentManualVerificationModalProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgDocumentsUrl}
            illustration={byDesign(undefined, NoBillingMethodsIllustration)}
          />
          <ModalSheetContentTitle>
            Are you sure this is the right file?
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            {isMissingProSignature ? (
              <>
                The preparer&apos;s{' '}
                <strong className={styles.bold}>signature</strong> appears to be
                missing from this final return, which needs to be mailed. Are
                you sure this is the right file?
              </>
            ) : (
              <>
                The <strong className={styles.bold}>name</strong> on this
                document does not appear to match the expected client. Are you
                sure this is the right file?
              </>
            )}
          </ModalSheetContentDescription>

          <div className={styles.viewDocument}>
            <Button
              label="View Document"
              variant={hasViewedDocument ? 'secondary' : 'primary'}
              onPress={onViewDocument}
            />
          </div>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer>
          {!hasViewedDocument && (
            <div className={styles.viewHint}>
              View the document before confirming or deleting.
            </div>
          )}
        </ModalSheetFooterSpacer>
        <ModalSheetFooterButtonGroup>
          <Button
            label="Yes, it's the right file"
            variant="primary"
            isDisabled={!hasViewedDocument}
            onPress={onConfirmDocument}
          />
          <Button
            label="No, delete it"
            variant="destructive"
            isDisabled={!hasViewedDocument}
            onPress={onDeleteDocument}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
